const SCHEMA: string = process.env.REACT_APP_MASTER_LOGIN_SCHEMA || '';
const ENTITY: string = process.env.REACT_APP_MASTER_LOGIN_ENTITY || '';


export const AdapterConfigure = {
    SCHEMA,
    ENTITY,
};